import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
